import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.686 1.667h6.628l3.019 3.019v6.628l-3.019 3.019H4.686l-3.019-3.019V4.686z", fill: "#C94841" }), /* @__PURE__ */ React.createElement("path", { d: "M8 4.8v4.27", stroke: "white", strokeWidth: 1.2, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 11.2, r: 0.85, fill: "white" }));
const ForwardRef = forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
